var Midttrafik2016 = Midttrafik2016 || {}

Midttrafik2016.widgets = new function () {
    var self = this

    this.init = function () {
        self.initWidgetHeight();
    }

    this.initWidgetHeight = function () {
        var winWidth = window.innerWidth;
        // Select and loop the container element of the elements you want to equalise
        if (winWidth > 992) {
            if ($(".grey-widget").length && $(".widget-row .news-widget").length) {
                if ($(".widget-row .news-widget").height() <= $(".grey-widget").height()) {
                    $(".widget-row .news-widget-content").height($(".grey-widget").height() - 10);
                } else {
                    $(".grey-widget-content").height($(".widget-row .news-widget-content").height() - 20);
                }
            }
        } else {
            $(".grey-widget-content").height("auto");
            $(".widget-row .news-widget-content").height("auto");
        }
        
        
    }
}